import api from "./api";
import { getWebPushPublicKey } from "../config";

const base64UrlToUint8Array = base64UrlString => {
  const normalizedString = `${base64UrlString || ""}`.trim();
  if (!normalizedString) {
    return null;
  }

  const padding = "=".repeat((4 - (normalizedString.length % 4)) % 4);
  const base64 = `${normalizedString}${padding}`
    .replace(/-/g, "+")
    .replace(/_/g, "/");
  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let index = 0; index < rawData.length; index += 1) {
    outputArray[index] = rawData.charCodeAt(index);
  }

  return outputArray;
};

export const registerWebPushSubscription = async () => {
  if (
    !("serviceWorker" in navigator) ||
    !("PushManager" in window) ||
    !("Notification" in window)
  ) {
    return null;
  }

  if (Notification.permission !== "granted") {
    return null;
  }

  const publicKey = `${getWebPushPublicKey() || ""}`.trim();
  if (!publicKey) {
    return null;
  }

  const applicationServerKey = base64UrlToUint8Array(publicKey);
  if (!applicationServerKey) {
    return null;
  }

  const registration =
    (await navigator.serviceWorker.getRegistration()) ||
    (await navigator.serviceWorker.ready);

  if (!registration?.pushManager) {
    return null;
  }

  let subscription = await registration.pushManager.getSubscription();
  if (!subscription) {
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey
    });
  }

  const serializedSubscription = subscription.toJSON();

  await api.post("/push/subscriptions", serializedSubscription);
  return serializedSubscription;
};

export const unregisterWebPushSubscription = async endpoint => {
  const normalizedEndpoint = `${endpoint || ""}`.trim();
  if (!normalizedEndpoint) {
    return;
  }

  await api.delete("/push/subscriptions", {
    data: {
      endpoint: normalizedEndpoint
    }
  });
};
